// @flow
import { createReducer } from "state/utils";
import * as sessionTypes from "state/ducks/integrations/types";
import * as uiTypes from "./types";

const INITIAL_STATE = {
  error: false,
  isFetching: true,
  message: "",
  messageType: "warning"
};

export default createReducer(INITIAL_STATE)({
  [sessionTypes.SLACK_INSTALL_FAILED]: (state, action) => {
    const errors = action.error.response;
    return {
      ...state,
      error: true,
      isFetching: false,
      message: errors,
      messageType: "warning"
    };
  },
  [sessionTypes.SLACK_INSTALL_COMPLETED]: state => ({
    ...state,
    error: false,
    isFetching: false,
    messageType: "success",
    message: "You have successfully signed in."
  }),
  [sessionTypes.SLACK_INSTALL_REQUESTED]: state => ({
    ...state,
    error: false,
    isFetching: true,
    message: ""
  }),
  [uiTypes.CLEAR_PAGE]: () => INITIAL_STATE
});
